export class ShowPopupData {
  isShowFeedbackPopup = false;
  constructor(fields?: Partial<ShowPopupData>) {
    Object.assign(this, fields);
  }
}
